import { render, staticRenderFns } from "./EduCooperation.vue?vue&type=template&id=6a119d76&scoped=true"
import script from "./EduCooperation.vue?vue&type=script&lang=js"
export * from "./EduCooperation.vue?vue&type=script&lang=js"
import style0 from "./EduCooperation.vue?vue&type=style&index=0&id=6a119d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a119d76",
  null
  
)

export default component.exports